import type { Business } from "@/types/directory";

export const businessesPartB: Business[] = [
  {
    id: "biz-09",
    slug: "manipal-wellness-hospital",
    name: "Manipal Wellness Hospital",
    tagline: "Compassionate care for Udupi and beyond",
    description:
      "A modern 90-bed hospital in Manipal with dedicated departments for orthopaedics, gastroenterology, nephrology and preventive health, supported by a NABL-accredited diagnostics laboratory.",
    categorySlug: "healthcare",
    subcategory: "Multispeciality Hospitals",
    districtSlug: "udupi",
    locationSlug: "manipal",
    address: "Tiger Circle Road, Manipal, Udupi District - 576104",
    phone: "+91 820 257 7700",
    whatsapp: "+91 94812 77700",
    email: "frontdesk@manipalwellness.in",
    website: "https://manipalwellness.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Manipal%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Contemporary%20wellness%20hospital%20reception%20with%20calming%20neutral%20interior%2C%20indoor%20plants%20and%20soft%20natural%20light%2C%20welcoming%20healthcare%20interior%20photography&width=1200&height=800&seq=cbc-biz-manipal-wellness-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Modern%20bright%20hospital%20consultation%20room%20with%20clean%20minimal%20interior%20and%20natural%20light%2C%20healthcare%20interior%20photography&width=1200&height=800&seq=cbc-biz-manipal-wellness-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Advanced%20hospital%20diagnostic%20lab%20with%20modern%20equipment%20and%20clean%20clinical%20environment%2C%20healthcare%20technology%20photography&width=1200&height=800&seq=cbc-biz-manipal-wellness-g2-01&orientation=landscape",
    ],
    rating: 4.6,
    reviewCount: 534,
    verified: true,
    sponsored: false,
    featured: true,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 14,
    hours: [
      { day: "Monday", open: "08:00", close: "20:00", closed: false },
      { day: "Tuesday", open: "08:00", close: "20:00", closed: false },
      { day: "Wednesday", open: "08:00", close: "20:00", closed: false },
      { day: "Thursday", open: "08:00", close: "20:00", closed: false },
      { day: "Friday", open: "08:00", close: "20:00", closed: false },
      { day: "Saturday", open: "08:00", close: "18:00", closed: false },
      { day: "Sunday", open: "09:00", close: "13:00", closed: false },
    ],
    services: ["Orthopaedics", "Gastroenterology", "Nephrology", "Health Checkups"],
    tags: ["NABL Lab", "Health Packages", "Insurance", "Emergency"],
    reviews: [
      {
        id: "rev-09-1",
        author: "Prashanth U.",
        rating: 5,
        date: "2026-08-08",
        comment: "Well-managed hospital with attentive doctors. The health checkup package was thorough.",
        verified: true,
      },
      {
        id: "rev-09-2",
        author: "Meera Nair",
        rating: 4,
        date: "2026-07-04",
        comment: "Clean facilities and good staff. Appointment booking online would be helpful.",
        verified: true,
      },
    ],
  },
  {
    id: "biz-10",
    slug: "kundapura-lighthouse-beach-resort",
    videoUrl: "https://youtu.be/aqz-KE-bpKQ",
    name: "Kundapura Lighthouse Beach Resort",
    tagline: "Sea-facing luxury on the Udupi coast",
    description:
      "A boutique beachfront resort in Kundapura with sea-view cottages, an infinity pool, authentic coastal seafood dining and curated backwater experiences for travellers exploring the Udupi coast.",
    categorySlug: "hotels",
    subcategory: "Beach Resorts",
    districtSlug: "udupi",
    locationSlug: "kundapura",
    address: "Beach Road, Kundapura, Udupi District - 576201",
    phone: "+91 8254 230 500",
    whatsapp: "+91 97318 30500",
    email: "stay@kundapuralighthouse.in",
    website: "https://kundapuralighthouse.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Kundapura%20Beach%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Serene%20beachfront%20resort%20with%20infinity%20pool%20overlooking%20the%20Arabian%20Sea%20and%20coconut%20palms%2C%20golden%20hour%20lighting%2C%20luxury%20coastal%20hospitality%20photography&width=1200&height=800&seq=cbc-biz-kundapura-resort-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Sea%20view%20resort%20cottage%20with%20wooden%20deck%2C%20open%20windows%20and%20warm%20interior%20lighting%2C%20luxury%20coastal%20stay%20photography&width=1200&height=800&seq=cbc-biz-kundapura-resort-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Authentic%20coastal%20seafood%20platter%20served%20at%20a%20seaside%20dining%20table%2C%20warm%20sunset%20lighting%2C%20food%20and%20travel%20photography&width=1200&height=800&seq=cbc-biz-kundapura-resort-g2-01&orientation=landscape",
    ],
    rating: 4.8,
    reviewCount: 372,
    verified: true,
    sponsored: true,
    featured: true,
    plan: "Premium",
    openNow: true,
    yearsInBusiness: 8,
    hours: [
      { day: "Monday", open: "00:00", close: "23:59", closed: false },
      { day: "Tuesday", open: "00:00", close: "23:59", closed: false },
      { day: "Wednesday", open: "00:00", close: "23:59", closed: false },
      { day: "Thursday", open: "00:00", close: "23:59", closed: false },
      { day: "Friday", open: "00:00", close: "23:59", closed: false },
      { day: "Saturday", open: "00:00", close: "23:59", closed: false },
      { day: "Sunday", open: "00:00", close: "23:59", closed: false },
    ],
    services: ["Sea View Cottages", "Infinity Pool", "Seafood Dining", "Backwater Tours"],
    tags: ["Beachfront", "Pool", "Seafood", "Boutique Resort"],
    reviews: [
      {
        id: "rev-10-1",
        author: "Arjun Rodrigues",
        rating: 5,
        date: "2026-08-15",
        comment: "Waking up to that sea view was worth every rupee. The seafood dinner was exceptional.",
        verified: true,
      },
      {
        id: "rev-10-2",
        author: "Nikhil Shetty",
        rating: 5,
        date: "2026-07-27",
        comment: "Beautiful property, warm staff and a stunning infinity pool. Highly recommended for a weekend.",
        verified: true,
      },
      {
        id: "rev-10-3",
        author: "Pooja M.",
        rating: 4,
        date: "2026-06-18",
        comment: "Lovely location and great food. Only thing, the drive in is narrow for a big car.",
        verified: false,
      },
    ],
  },
  {
    id: "biz-11",
    slug: "karkala-vidya-coaching-academy",
    name: "Karkala Vidya Coaching Academy",
    tagline: "NEET, JEE and KCET coaching for the coast",
    description:
      "A results-focused coaching academy in Karkala offering NEET, JEE, KCET and PU science tuition with experienced faculty, weekly assessments, doubt-clearing sessions and parent progress reports.",
    categorySlug: "education",
    subcategory: "Coaching Academies",
    districtSlug: "udupi",
    locationSlug: "karkala",
    address: "College Road, Karkala, Udupi District - 574104",
    phone: "+91 8258 231 450",
    whatsapp: "+91 99862 31450",
    email: "admissions@vidyacoaching.in",
    website: "https://vidyacoaching.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Karkala%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20modern%20coaching%20academy%20classroom%20with%20rows%20of%20desks%2C%20whiteboard%20and%20large%20windows%2C%20clean%20educational%20interior%20photography&width=1200&height=800&seq=cbc-biz-karkala-coaching-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Students%20studying%20attentively%20in%20a%20bright%20classroom%20with%20notebooks%2C%20focused%20learning%20atmosphere%20photography&width=1200&height=800&seq=cbc-biz-karkala-coaching-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Well%20stocked%20modern%20study%20library%20with%20books%20and%20quiet%20reading%20tables%2C%20bright%20academic%20environment%20photography&width=1200&height=800&seq=cbc-biz-karkala-coaching-g2-01&orientation=landscape",
    ],
    rating: 4.7,
    reviewCount: 208,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Business",
    openNow: false,
    yearsInBusiness: 11,
    hours: [
      { day: "Monday", open: "07:00", close: "20:00", closed: false },
      { day: "Tuesday", open: "07:00", close: "20:00", closed: false },
      { day: "Wednesday", open: "07:00", close: "20:00", closed: false },
      { day: "Thursday", open: "07:00", close: "20:00", closed: false },
      { day: "Friday", open: "07:00", close: "20:00", closed: false },
      { day: "Saturday", open: "07:00", close: "18:00", closed: false },
      { day: "Sunday", open: "08:00", close: "13:00", closed: false },
    ],
    services: ["NEET Coaching", "JEE Coaching", "KCET Coaching", "PU Science Tuition"],
    tags: ["Results Focused", "Experienced Faculty", "Assessments", "Doubt Sessions"],
    reviews: [
      {
        id: "rev-11-1",
        author: "Ramesh Acharya",
        rating: 5,
        date: "2026-08-01",
        comment: "My daughter improved hugely in physics and chemistry here. The regular assessments really helped.",
        verified: true,
      },
      {
        id: "rev-11-2",
        author: "Sunitha Kumar",
        rating: 4,
        date: "2026-07-09",
        comment: "Dedicated teachers and good study material. Batch sizes are well managed.",
        verified: true,
      },
    ],
  },
  {
    id: "biz-12",
    slug: "udupi-coastal-electronics",
    name: "Udupi Coastal Electronics",
    tagline: "Home appliances and gadgets at honest prices",
    description:
      "A trusted electronics and home appliance showroom in Udupi city offering televisions, refrigerators, washing machines and air conditioners with EMI options, installation and service support.",
    categorySlug: "electronics",
    subcategory: "Home Appliances",
    districtSlug: "udupi",
    locationSlug: "udupi-city",
    address: "Diana Circle, Udupi, Udupi District - 576101",
    phone: "+91 820 252 9900",
    whatsapp: "+91 98456 29900",
    email: "sales@coastalelectronics.in",
    website: "https://coastalelectronics.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Diana%20Circle%20Udupi%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20home%20electronics%20and%20appliance%20showroom%20interior%20with%20neatly%20arranged%20televisions%20and%20appliances%20under%20bright%20display%20lighting%2C%20retail%20photography&width=1200&height=800&seq=cbc-biz-udupi-electronics-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Row%20of%20large%20flat%20screen%20televisions%20on%20display%20wall%20in%20a%20bright%20electronics%20store%2C%20retail%20photography&width=1200&height=800&seq=cbc-biz-udupi-electronics-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Modern%20kitchen%20appliances%20including%20refrigerator%20and%20washing%20machine%20displayed%20in%20a%20showroom%2C%20bright%20lighting%2C%20retail%20photography&width=1200&height=800&seq=cbc-biz-udupi-electronics-g2-01&orientation=landscape",
    ],
    rating: 4.3,
    reviewCount: 176,
    verified: false,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 10,
    hours: [
      { day: "Monday", open: "09:30", close: "20:30", closed: false },
      { day: "Tuesday", open: "09:30", close: "20:30", closed: false },
      { day: "Wednesday", open: "09:30", close: "20:30", closed: false },
      { day: "Thursday", open: "09:30", close: "20:30", closed: false },
      { day: "Friday", open: "09:30", close: "20:30", closed: false },
      { day: "Saturday", open: "09:30", close: "21:00", closed: false },
      { day: "Sunday", open: "10:00", close: "20:00", closed: false },
    ],
    services: ["Televisions", "Refrigerators", "Washing Machines", "Air Conditioners"],
    tags: ["EMI Available", "Installation", "Brand Warranty", "Service Support"],
    reviews: [
      {
        id: "rev-12-1",
        author: "Girish Rao",
        rating: 4,
        date: "2026-07-31",
        comment: "Good prices and they handled installation the next day itself. Happy with the purchase.",
        verified: true,
      },
    ],
  },
  {
    id: "biz-13",
    slug: "karwar-blue-bay-electronics",
    name: "Karwar Blue Bay Electronics",
    tagline: "Computers, mobiles and CCTV across North Canara",
    description:
      "A leading electronics and IT store in Karwar selling laptops, smartphones, printers and CCTV systems, with on-site installation, annual maintenance contracts and skilled repair services.",
    categorySlug: "electronics-mobiles",
    subcategory: "Repairs & CCTV",
    districtSlug: "north-canara",
    locationSlug: "karwar",
    address: "Main Road, Karwar, Uttara Kannada - 581301",
    phone: "+91 8382 226 600",
    whatsapp: "+91 94487 26600",
    email: "sales@bluebayeletronics.in",
    website: "https://bluebayeletronics.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Karwar%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Contemporary%20electronics%20store%20interior%20with%20clean%20display%20shelves%2C%20laptops%20and%20gadgets%20under%20bright%20lighting%2C%20professional%20technology%20retail%20photography&width=1200&height=800&seq=cbc-biz-karwar-electronics-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Neat%20row%20of%20laptops%20and%20tablets%20on%20display%20counters%20in%20a%20modern%20store%2C%20bright%20lighting%2C%20technology%20retail%20photography&width=1200&height=800&seq=cbc-biz-karwar-electronics-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Technician%20installing%20CCTV%20cameras%20in%20a%20modern%20building%2C%20professional%20security%20installation%20photography&width=1200&height=800&seq=cbc-biz-karwar-electronics-g2-01&orientation=landscape",
    ],
    rating: 4.5,
    reviewCount: 143,
    verified: true,
    sponsored: false,
    featured: true,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 13,
    hours: [
      { day: "Monday", open: "09:30", close: "20:00", closed: false },
      { day: "Tuesday", open: "09:30", close: "20:00", closed: false },
      { day: "Wednesday", open: "09:30", close: "20:00", closed: false },
      { day: "Thursday", open: "09:30", close: "20:00", closed: false },
      { day: "Friday", open: "09:30", close: "20:00", closed: false },
      { day: "Saturday", open: "09:30", close: "20:30", closed: false },
      { day: "Sunday", open: "10:00", close: "14:00", closed: false },
    ],
    services: ["Laptops & PCs", "Smartphones", "CCTV Systems", "AMC & Repairs"],
    tags: ["IT Store", "CCTV Installation", "AMC", "Authorised Service"],
    reviews: [
      {
        id: "rev-13-1",
        author: "Mahesh Naik",
        rating: 5,
        date: "2026-08-06",
        comment: "Got CCTV installed for our shop. Professional work and they respond quickly for support.",
        verified: true,
      },
      {
        id: "rev-13-2",
        author: "Sandeep K.",
        rating: 4,
        date: "2026-06-29",
        comment: "Good range of laptops and fair pricing. Repair turnaround was quick.",
        verified: true,
      },
    ],
  },
  {
    id: "biz-14",
    slug: "sirsi-spice-cafe",
    name: "Sirsi Spice Cafe",
    tagline: "Coffee, snacks and a warm corner in Sirsi",
    description:
      "A cosy cafe in Sirsi serving freshly brewed coffee, homemade bakes, sandwiches and North Canara specialities, with free Wi-Fi and a relaxed space for students and travellers alike.",
    categorySlug: "restaurants",
    subcategory: "Cafes & Bakeries",
    districtSlug: "north-canara",
    locationSlug: "sirsi",
    address: "Market Road, Sirsi, Uttara Kannada - 581401",
    phone: "+91 8384 224 700",
    whatsapp: "+91 97416 24700",
    email: "hello@sirsispicecafe.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=Sirsi%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20cafe%20interior%20with%20rustic%20wooden%20furniture%2C%20hanging%20plants%20and%20warm%20pendant%20lighting%2C%20aromatic%20coffee%20counter%2C%20inviting%20editorial%20cafe%20photography&width=1200&height=800&seq=cbc-biz-sirsi-cafe-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Freshly%20brewed%20coffee%20with%20latte%20art%20and%20a%20slice%20of%20cake%20on%20a%20rustic%20wooden%20table%2C%20warm%20lighting%2C%20food%20photography&width=1200&height=800&seq=cbc-biz-sirsi-cafe-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Homemade%20bakes%20and%20sandwiches%20neatly%20arranged%20on%20a%20counter%20in%20a%20cosy%20cafe%2C%20warm%20inviting%20lighting%2C%20food%20photography&width=1200&height=800&seq=cbc-biz-sirsi-cafe-g2-01&orientation=landscape",
    ],
    rating: 4.4,
    reviewCount: 118,
    verified: false,
    sponsored: true,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 4,
    hours: [
      { day: "Monday", open: "08:00", close: "22:00", closed: false },
      { day: "Tuesday", open: "08:00", close: "22:00", closed: false },
      { day: "Wednesday", open: "08:00", close: "22:00", closed: false },
      { day: "Thursday", open: "08:00", close: "22:00", closed: false },
      { day: "Friday", open: "08:00", close: "22:30", closed: false },
      { day: "Saturday", open: "08:00", close: "22:30", closed: false },
      { day: "Sunday", open: "09:00", close: "22:00", closed: false },
    ],
    services: ["Coffee & Brews", "Homemade Bakes", "Sandwiches", "Free Wi-Fi"],
    tags: ["Cafe", "Wi-Fi", "Students Welcome", "Takeaway"],
    reviews: [
      {
        id: "rev-14-1",
        author: "Akshata P.",
        rating: 5,
        date: "2026-07-24",
        comment: "Lovely little cafe. Great coffee and the staff are so warm. Perfect place to work for an hour.",
        verified: true,
      },
    ],
  },
  {
    id: "biz-15",
    slug: "bhatkal-coastal-motors",
    name: "Bhatkal Coastal Motors",
    tagline: "Trusted two-wheeler sales and service",
    description:
      "An authorised two-wheeler dealership and service workshop in Bhatkal offering new and used bikes, genuine spares, quick servicing and easy finance options for customers across North Canara.",
    categorySlug: "automobile",
    subcategory: "Two-Wheeler Dealers",
    districtSlug: "north-canara",
    locationSlug: "bhatkal",
    address: "NH-66, Bhatkal, Uttara Kannada - 581320",
    phone: "+91 8385 226 300",
    whatsapp: "+91 96329 26300",
    email: "care@coastalmotorsbhatkal.in",
    website: "https://coastalmotorsbhatkal.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Bhatkal%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Automobile%20service%20workshop%20with%20lifts%20and%20neatly%20organized%20tools%2C%20bright%20clean%20industrial%20lighting%2C%20professional%20automotive%20service%20photography&width=1200&height=800&seq=cbc-biz-bhatkal-motors-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Neat%20row%20of%20new%20motorcycles%20on%20display%20inside%20a%20bright%20two-wheeler%20showroom%2C%20professional%20retail%20photography&width=1200&height=800&seq=cbc-biz-bhatkal-motors-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Mechanic%20servicing%20a%20motorcycle%20in%20a%20clean%20well-equipped%20workshop%2C%20bright%20lighting%2C%20automotive%20service%20photography&width=1200&height=800&seq=cbc-biz-bhatkal-motors-g2-01&orientation=landscape",
    ],
    rating: 4.2,
    reviewCount: 96,
    verified: false,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 6,
    hours: [
      { day: "Monday", open: "09:00", close: "19:30", closed: false },
      { day: "Tuesday", open: "09:00", close: "19:30", closed: false },
      { day: "Wednesday", open: "09:00", close: "19:30", closed: false },
      { day: "Thursday", open: "09:00", close: "19:30", closed: false },
      { day: "Friday", open: "09:00", close: "19:30", closed: false },
      { day: "Saturday", open: "09:00", close: "20:00", closed: false },
      { day: "Sunday", open: "10:00", close: "14:00", closed: false },
    ],
    services: ["New Two-Wheelers", "Used Bikes", "Servicing", "Spare Parts & Finance"],
    tags: ["Two-Wheeler", "Quick Service", "Finance Options", "Genuine Spares"],
    reviews: [
      {
        id: "rev-15-1",
        author: "Imran S.",
        rating: 4,
        date: "2026-07-13",
        comment: "Service was quick and reasonably priced. They explained what needed replacing.",
        verified: true,
      },
    ],
  },
  {
    id: "biz-16",
    slug: "ankola-green-grocers",
    name: "Ankola Green Grocers",
    tagline: "Fresh local produce, straight from the coast",
    description:
      "A friendly neighbourhood supermarket and fresh produce store in Ankola stocking farm-fresh vegetables, local spices, groceries and household essentials with daily provisions and doorstep delivery.",
    categorySlug: "supermarkets",
    subcategory: "Fresh Vegetables",
    districtSlug: "north-canara",
    locationSlug: "ankola",
    address: "Main Bazaar, Ankola, Uttara Kannada - 581314",
    phone: "+91 8388 230 110",
    whatsapp: "+91 90087 30110",
    email: "orders@ankolagrocers.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=Ankola%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Well%20stocked%20local%20supermarket%20with%20fresh%20vegetables%20and%20organized%20shelves%2C%20bright%20clean%20lighting%2C%20welcoming%20grocery%20retail%20photography&width=1200&height=800&seq=cbc-biz-ankola-grocers-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Baskets%20of%20vibrant%20fresh%20vegetables%20neatly%20arranged%20at%20a%20local%20market%2C%20bright%20natural%20light%2C%20food%20retail%20photography&width=1200&height=800&seq=cbc-biz-ankola-grocers-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Jars%20of%20aromatic%20local%20Indian%20spices%20on%20a%20clean%20store%20shelf%2C%20warm%20lighting%2C%20retail%20photography&width=1200&height=800&seq=cbc-biz-ankola-grocers-g2-01&orientation=landscape",
    ],
    rating: 4.3,
    reviewCount: 74,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 5,
    hours: [
      { day: "Monday", open: "07:00", close: "20:30", closed: false },
      { day: "Tuesday", open: "07:00", close: "20:30", closed: false },
      { day: "Wednesday", open: "07:00", close: "20:30", closed: false },
      { day: "Thursday", open: "07:00", close: "20:30", closed: false },
      { day: "Friday", open: "07:00", close: "20:30", closed: false },
      { day: "Saturday", open: "07:00", close: "21:00", closed: false },
      { day: "Sunday", open: "07:00", close: "19:30", closed: false },
    ],
    services: ["Fresh Vegetables", "Local Spices", "Groceries", "Doorstep Delivery"],
    tags: ["Farm Fresh", "Local Spices", "Delivery", "Daily Needs"],
    reviews: [
      {
        id: "rev-16-1",
        author: "Savita N.",
        rating: 4,
        date: "2026-08-03",
        comment: "Good fresh stock and friendly service. The local spices are excellent.",
        verified: true,
      },
    ],
  },
];